import React, { PureComponent, ReactNode } from "react";
import { AppContextType } from "../../AppContext";
import { SmartAutoSetting } from "../../models/KeySelectionOptions.model";
import OptionMenuOneLineToggle from "../theme_reuse/OptionMenuOneLineToggle";

interface Props {}
interface State {}

const shortNames = [SmartAutoSetting.Manual, SmartAutoSetting.AlwaysAuto, SmartAutoSetting.ContextualAuto];

function printShortName(x: SmartAutoSetting): string {
  switch (x) {
    case SmartAutoSetting.Manual:
      return "Do not automate";
    case SmartAutoSetting.ContextualAuto:
      return "Unless a Blues scale is likely";
    case SmartAutoSetting.AlwaysAuto:
      return "Auto-silence Flat 5th";
  }
}

export default class AutoIgnore5Toggle extends PureComponent<Props, State> {
  declare context: React.ContextType<typeof AppContextType>;
  constructor(props: Props) {
    super(props);
    this.state = {};
  }

  changeSetting = (flat5Ignore: SmartAutoSetting) => {
    const oldOptions = this.context.keySelectionOptions;
    this.context.dispatch({
      type: "EditKeySelectionOptions",
      payload: { ...oldOptions, autoPin: { ...oldOptions.autoPin, flat5Ignore } },
    });
  };

  render(): ReactNode {
    const selected = this.context.keySelectionOptions.autoPin.flat5Ignore;
    return (
      <OptionMenuOneLineToggle
        selected={selected}
        printShortName={printShortName}
        onChange={this.changeSetting}
        optionShortNames={shortNames}
      />
    );
  }
}

AutoIgnore5Toggle.contextType = AppContextType;
